module.exports = "/_next/static/images/monitor-line-d90b441a6dfb8d7b9d324ff39479a151.svg";